module.exports = __webpack_public_path__ + "img/nie-umiem.f00a4ec0.png";